module.exports = __webpack_public_path__ + "img/sales.86813906.svg";